import { useEffect, useRef, useState } from "react";
import ProductAvailabilityEntry from "./productavailability-entry";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import {
  Grid,
  GridCellProps,
  GridColumn,
  GridColumnMenuFilter,
  GridColumnMenuProps,
  GridDataStateChangeEvent,
  GridExpandChangeEvent,
  GridNoRecords,
} from "@progress/kendo-react-grid";

import {
  setExpandedState,
  setGroupIds,
} from "@progress/kendo-react-data-tools";
import { DataResult, process, State } from "@progress/kendo-data-query";
import { useGetProductAvailabilities } from "../../apiclient/product/useGetProductAvailabilityApi";
import { url } from "inspector";
import CategoryModel from "../../models/masters/category-model";
import { SubmitStatus } from "../../core/formik-model-dialog.component";
import { API_END_POINT } from "../../constants";
import { GridCommandCell } from "../../core/grid-command-cell.component";
import { LoadingIndicator } from "../../core/loading-indicator.component";
import {
  DeleteModelDialog,
  DeletePostDataInfo,
  DeleteStatus,
} from "../../core/delete-model-dialog.component";
import ProductAvailabilityModel from "../../models/products/productavailability-model";
import { GridActionComponent } from "../../core/action.title.component";

export const addOrUpdateArrayItem = (data: any[], item: any, key: string) => {
  const newData = data ? [...data] : [];
  const index = data?.findIndex((d) => d[key] === item[key]);
  console.log("the index is" + index);
  if (index > -1) {
    newData.splice(index, 1, item);
  } else {
    newData.push(item);
  }
  return newData;
};

const ProductAvailabilityPage: React.FC = () => {
  const initialDataState: State = {
    take: 10,
    skip: 0,
    group: [],
  };
  const [dataState, setDataState] = useState<State>(initialDataState);
  const [deleteSubGroupData, setDeleteProductAvailabilityData] =
    useState<DeletePostDataInfo>();
  const [collapsedState, setCollapsedState] = useState<string[]>([]);
  const [resultData, setResultData] = useState<DataResult>();

  const [editModal, setEditModal] = useState<boolean>(false);
  const [editData, setEditdata] = useState<ProductAvailabilityModel>(null);
  const exportExcel = useRef<ExcelExport | null>(null);

  const [pgreset, setpgreset] = useState<boolean>(false);
  const [viewModal, setViewModal] = useState<boolean>(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const {
    data: result,
    isLoading,
    isError,
    refetch: reloadProductAvailability,
  } = useGetProductAvailabilities();

  const processWithGroups = (
    data: ProductAvailabilityModel[],
    dataState: State
  ) => {
    const groups = dataState.group;
    dataState.group = groups;
    const newDataState = process(data, dataState);
    setGroupIds({ data: newDataState.data, group: dataState.group });
    return newDataState;
  };
  const fetchData = async () => {
    try {
      setIsRefreshing(true);
      const { data, error } = await reloadProductAvailability();
      if (error) {
        console.error("Error reloading:", error);
      } else {
        console.log("Reloaded data:", data);
      }
    } catch (err) {
      console.error("Unexpected error:", err);
    } finally {
      setIsRefreshing(false);
    }
  };
  useEffect(() => {
    setEditdata(null);
    fetchData();
    if (result) {
      setResultData(processWithGroups(result, initialDataState));
    }
  }, [result]);

  let newData: any = null;
  if (resultData) {
    newData = setExpandedState({
      data: resultData.data,
      collapsedIds: collapsedState,
    });
  }

  const onSaveComplete = (
    status: SubmitStatus,
    data: ProductAvailabilityModel
  ) => {
    setEditdata(null);
    if (status === SubmitStatus.Completed) {
      reloadProductAvailability();
      setResultData(processWithGroups(newData, dataState));
    }
  };

  const excelExport = () => {
    if (exportExcel.current !== null) {
      exportExcel.current.save();
    }
  };

  // const onAddNew = () => {
  //   setEditModal(true);
  //   setEditdata(new ProductAvailabilityModel());
  // };
  const onView = (data: ProductAvailabilityModel) => {
    setViewModal(true);
    setEditdata(data);
  };
  const onEdit = (data: ProductAvailabilityModel) => {
    setEditModal(true);
    setViewModal(false);
    setEditdata(data);
  };

  // const onRemove = (data: ProductAvailabilityModel) => {
  //     const { productavailabilityid } = data;
  //     console.log(data)
  //     setDeleteProductAvailabilityData({
  //         data,
  //         route: `SubGroup/DeleteSubGroup/${productavailabilityid}`,
  //         endpoint: API_END_POINT.PRODUCT,
  //     });
  //     reloadProductAvailability();
  // };
  const onDeleteComplete = (
    status: DeleteStatus,
    data: ProductAvailabilityModel
  ) => {
    if (status === DeleteStatus.Completed) {
      reloadProductAvailability();
      setResultData(processWithGroups(result, dataState));
    }
    setDeleteProductAvailabilityData(null);
  };
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };

  const CommandCell = (props: GridCellProps) => (
    <GridCommandCell
      {...props}
      edit={onEdit}
      // remove={onRemove}
      // add={onAddNew}
      dataItem={props.dataItem}
      idPropertyName="productId"
      editPermissionName={null}
      deletePermissionName={null}
      view={onView}
    />
  );

  const onSearch = (e: any) => {
    if (e.target.value.length > 0) {
      const searchKey: string = e.target.value;
      const filteredData = result?.filter((p) =>
        p?.productName?.toLowerCase().includes(searchKey?.toLowerCase())
      );
      setResultData(process(filteredData, dataState));
    } else {
      setResultData(process(result, dataState));
    }
  };

  const expandChange = (event: GridExpandChangeEvent) => {
    const item = event.dataItem;

    if (item.groupId) {
      const newCollapsedIds = !event.value
        ? [...collapsedState, item.groupId]
        : collapsedState.filter((groupId) => groupId !== item.groupId);
      setCollapsedState(newCollapsedIds);
    }
  };

  const ColumnFormatBoolean = (props: any) => {
    return (
      <td
        {...props.tdProps}
        colSpan={1}
        style={{
          color: "black",
        }}
      >
        {props.children === "true" ? (
          <span style={{ color: "green", fontWeight: "bold" }}>Yes</span>
        ) : (
          <span style={{ color: "red", fontWeight: "bold" }}>No</span>
        )}
      </td>
    );
  };
  
  const refreshGrid = () => {
    reloadProductAvailability();
  };
  const dataStateChange = (event: GridDataStateChangeEvent) => {
    const newDataState = processWithGroups(result, event.dataState);
    setResultData(newDataState);
    setDataState(event.dataState);
  };
  // const onAddClick = () => {
  //   setEditModal(true);
  //   setViewModal(false);
  //   setEditdata(new ProductAvailabilityModel());
  // };

  let grid = null;
  if (result) {
    grid = (
      <Grid
        data={newData}
        pageable={{ pageSizes: [10, 20, 50, 100] }}
        total={resultData?.total}
        groupable={true}
        sortable={true}
        onDataStateChange={dataStateChange}
        {...dataState}
        onExpandChange={expandChange}
        columnVirtualization={false}
        resizable={true} 

      >
       
        <GridColumn
          field="productName"
          title="Product Name"
          columnMenu={ColumnMenu}
        />
        <GridColumn
          field="morningAvailability"
          title="Morning Available"
          cells={{ data: ColumnFormatBoolean }}
        />
        <GridColumn
          field="eveningAvailability"
          title="Evening Available"
          cells={{ data: ColumnFormatBoolean }}
        />
        <GridColumn
          cell={CommandCell}
          title="Action"
          groupable={true}
        />
        <GridNoRecords>
          <div className="mt-2" style={{ width: "100%", height: "500px" }}>
            <center>
              <h5>No data found</h5>
            </center>
          </div>
        </GridNoRecords>
      </Grid>
    );
    if (isError) {
      return (
        <div>
          <h4>Error Loadong Page..</h4>
        </div>
      );
    }
    return (
      <>
        <div
          style={{ minHeight: "600px" }}
          className="card p-3 border-0 m-3 sw-shadow radius-15"
        >

<div>

            <GridActionComponent
              onSearchClick={onSearch}
              // addButtonClick={onAddClick}
              excelExportClick={excelExport}
              refreshClick={fetchData}
              title="PRODUCT AVAILABILITY"
              addButtonTooltip="Add Product Availability"
              showAddButton={false  }
            ></GridActionComponent>
          </div>

          {editModal && (
            <ProductAvailabilityEntry isViewMode = {viewModal} data={editData} onClose={onSaveComplete} />
          )}
          {viewModal && (
            <ProductAvailabilityEntry
              isViewMode={true}
              data={editData}
              onClose={onSaveComplete}
            />
          )}
          {/* {deleteSubGroupData && (
                        <DeleteModelDialog
                            title="Delete SubGroup"
                            deleteData={deleteSubGroupData}
                            onClose={onDeleteComplete}
                        >
                            <div>
                                Are you sure you want to delete SubGroup : <span style={{ fontWeight: "bold" }}>{deleteSubGroupData.data.name}</span>?

                            </div>
                        </DeleteModelDialog>
                    )} */}

          <div>
            <>
            {isRefreshing || isLoading ? (
                <LoadingIndicator isLoading={isRefreshing}></LoadingIndicator>
              ) : (
                <div>
              {grid}
              <ExcelExport
                fileName={"ProductAvailability_List"}
                data={result}
                ref={exportExcel}
              >
                <ExcelExportColumn
                  width={100}
                  field="productName"
                  title="Product Name"
                />
                <ExcelExportColumn
                  width={100}
                  field="morningAvailability"
                  title="Morning Available"
                />
                <ExcelExportColumn
                  width={150}
                  field="eveningAvailability"
                  title="Evening Available"
                />
              </ExcelExport>
              </div>
              )}
            </>
          </div>
          <div></div>
        </div>
      </>
    );
  }
};
export default ProductAvailabilityPage;
